export default __webpack_public_path__ + "static/media/web.02c5f53e.svg";